import * as React from 'react';
import Options from '../options/Options';

interface State {
	isWatchingUser: boolean;
	optionOn: boolean;
}

export class HybridizeButton extends React.Component<{}, State> {
	constructor(props: Readonly<{}>) {
		super(props);

		this.state = {
			isWatchingUser: false,
			optionOn: Options.getCurrent().showHybridizeButton,
		};

		document.body.addEventListener('watching-user', (e: CustomEvent) => this.setState({ isWatchingUser: e.detail.isWatchingUser }), false);
	}

	public render() {
		if (this.state.isWatchingUser || !this.state.optionOn) {
			return "";
		}

		return <button className='button hybridize-button' onClick={() => this.hybridize()}>
			HYBRIDIZE
		</button>
	}

	hybridize() {
		const elem = document.getElementById('renderCanvas');

		if (elem) {
			elem.dispatchEvent(new Event('hybridize'));
		}
	}
}